import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function OwnerPicker({ value, onChange }) {
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setLoading(true); setError("");
    api.get("/admin/platform/users", { params: { page, search: query } }).then(({ data }) => {
      if (!cancelled) { setUsers(data.users); setTotal(data.total); }
    }).catch((e) => { if (!cancelled) setError(apiError(e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [page, query, retry]);
  return <div className="space-y-3 rounded border border-zinc-800 p-3">
    <p className="text-sm font-medium">Propriétaire de l’organisation</p>
    <div className="flex gap-2">
      <Input aria-label="Rechercher un utilisateur" placeholder="Nom ou email" maxLength={120} value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); setPage(1); setQuery(search.trim()); } }} />
      <Button type="button" variant="outline" onClick={() => { setPage(1); setQuery(search.trim()); }}>Chercher</Button>
    </div>
    {error ? <p role="alert">{error} <button type="button" className="underline" onClick={() => setRetry(retry + 1)}>Réessayer</button></p> : loading ? <p role="status" className="text-xs">Chargement des utilisateurs…</p> : users.length === 0 ? <p className="text-xs text-zinc-400">Aucun utilisateur trouvé. Le propriétaire doit d’abord créer un compte client.</p> : (
      <ul className="max-h-52 space-y-2 overflow-y-auto">{users.map((u) => <li key={u.id}><label className="flex cursor-pointer items-center gap-2 text-sm"><input type="radio" name="organization-owner" checked={value?.id === u.id} onChange={() => onChange(u)} /><span>{u.name || u.email}<span className="block text-xs text-zinc-400">{u.email}</span></span></label></li>)}</ul>
    )}
    <div className="flex items-center justify-between gap-2 text-xs">
      <Button type="button" variant="outline" disabled={loading || page === 1} onClick={() => setPage(page - 1)}>Utilisateurs précédents</Button>
      <span>{total} utilisateur(s)</span>
      <Button type="button" variant="outline" disabled={loading || page * 20 >= total} onClick={() => setPage(page + 1)}>Utilisateurs suivants</Button>
    </div>
    <p className="text-xs text-zinc-400">{value ? `Propriétaire sélectionné : ${value.name || value.email} (${value.email})` : "Sélectionnez un utilisateur pour continuer."}</p>
    <p className="text-xs text-zinc-500">Seuls le nom et l’email sont affichés. La création lui attribue le rôle owner, sans donner d’accès interne au super admin.</p>
  </div>;
}
